var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddWindow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "currentColor",
    viewBox: "0 0 80 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.857 12.632h-8.539V4.126c0-2.273-1.86-4.126-4.142-4.126h-.127c-2.325 0-4.185 1.853-4.185 4.126v8.506h-8.497c-2.282 0-4.142 1.852-4.185 4.126v.126a4.16 4.16 0 0 0 4.185 4.169h8.497v8.463c0 2.274 1.86 4.168 4.185 4.126h.127c2.282 0 4.142-1.853 4.142-4.126v-8.463h8.54C78.14 21.053 80 19.2 80 16.926v-.168c0-2.274-1.86-4.126-4.143-4.126Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.954 25.632v4.252c0 4.59 3.762 8.337 8.37 8.38 1.452 0 2.766-.38 3.942-.98v5.494H37.37V13h6.044a8.065 8.065 0 0 0-1.142 4.126c0 2.358.888 4.463 2.452 6.063 1.606 1.558 3.72 2.443 5.96 2.443h4.27ZM29.896 13v29.778H0V21.42C0 16.79 3.804 13 8.454 13h21.442ZM0 50.222v21.725c0 3.201 1.817 6 4.475 7.424A7.436 7.436 0 0 0 7.474 80h22.422V50.222H0ZM37.37 80V50.222h29.896v22.334c0 4.094-3.364 7.444-7.474 7.444H37.37Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddWindow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_window.eff667264e15ca98ecd3368070349c00.svg";